import { PageHeader, Tabs } from 'antd';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { ExceptionsByInvestor } from '../components/investment-rules/ExceptionsByInvestor';
import { RulesByProduct } from '../components/investment-rules/RulesByProduct';

// Investment rules — NEW (no legacy screen; it replaces Retool P3 + P4 of the backend's RETOOL-GUIDE):
// the minimums, presets and default of each product, and the per-investor exceptions that win over
// them. Two tabs on one route; the active tab rides the URL (`?tab=exceptions`) so a refresh keeps it.
export function InvestmentRules() {
  const history = useHistory();
  const location = useLocation();
  const tab = qs.parse(location.search).tab === 'exceptions' ? 'exceptions' : 'rules';

  return (
    <>
      <PageHeader
        title="Investment rules"
        subTitle="Minimums per product, and the exceptions per investor"
        style={{ padding: '0 0 16px' }}
      />
      <Tabs
        activeKey={tab}
        onChange={(key) =>
          history.replace(key === 'rules' ? location.pathname : `${location.pathname}?tab=${key}`)
        }
      >
        <Tabs.TabPane tab="Rules by product" key="rules">
          <RulesByProduct />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Exceptions by investor" key="exceptions">
          <ExceptionsByInvestor />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
}
